/**
 * A STARTING TEXT for an organization's privacy and data use policy (ADR 0008 s6).
 *
 * This is a draft for the organization's counsel to review. It is not legal advice, it was not
 * written by a lawyer, and nothing publishes it: an Owner has to put it in the editor, read it,
 * change it, and press Publish. It is generic on purpose: it names no jurisdiction and cites no
 * statute, and everything in [square brackets] must be replaced or removed before publishing.
 * What it says about the product (what is logged, who can see what, how files are handled) is
 * true of this product and should stay true if the wording changes.
 */
export const DATA_POLICY_DRAFT_TITLE = 'Privacy and data use policy'

export const dataPolicyDraft = (
  organizationName: string,
) => `DRAFT FOR REVIEW BY COUNSEL. NOT LEGAL ADVICE. Replace everything in [square brackets] before publishing.

1. Who we are
${organizationName} ("we") operates this data room for the purpose of [describe the transaction or review, for example: evaluating a potential transaction]. Questions about this policy go to [name, role and contact address].

2. What this policy covers
It covers the documents and other information that you upload to a room of ${organizationName}, the answers and notes you give to requests in a room, and the record the data room keeps of your use of it.

3. What we collect
- The files you upload, their names, and the answers, reasons and notes you write.
- Your name and email address, as supplied when you were invited.
- A record of what you do in the room: signing in, viewing, downloading, uploading and answering, each with the time and the network (IP) address and browser it came from.
- The time and network address of your acceptance of this policy.

4. Why we collect it, and how we use it
We use what you provide only for the purpose stated in section 1. We use the activity record to keep the room secure, to show the owners of the room what has been provided and by whom, and to keep evidence of what was disclosed. We do not sell it and do not use it for marketing.

5. Personal information inside what you upload
Documents you upload may contain personal information about other people (for example employees). Upload only what the request asks for, remove or redact personal information that is not needed where you reasonably can, and upload it only if you are permitted to share it with us. [State any agreed handling for sensitive categories, for example identity documents, health, payroll or tax records.]

6. Who can see it
Access is by invitation and is set for each person, folder and document. What you upload can be seen by the staff of ${organizationName} who own the room, and by other people in the room only where the owners have granted them access. [Name the categories of adviser who may be given access, for example legal, tax and financial advisers.] Every upload is checked for malware before anyone can open it. Downloads may be watermarked with the name of the person downloading.

7. Where it is held, and for how long
The information is held in [hosting location or region] by our service providers acting on our instructions. We keep it for [retention period, or: the life of the transaction and then the period we are required to keep records], after which it is deleted or returned as [agreed]. When a room is closed, its owners may keep an archive of the room and its activity record.

8. Your choices
You may ask what we hold about you, ask us to correct it, or ask us to delete what we are not required to keep, by writing to the contact in section 1. [Add any rights that apply to the people concerned.]

9. Changes to this policy
If we change this policy we will publish a new version, and you will be asked to read and accept it before you next upload or answer a request.

By accepting, you confirm that you have read this policy and that you are permitted to provide the information you upload.
`
